import { render } from "./SVGUndo.vue?vue&type=template&id=34bc1290"
import script from "./SVGUndo.vue?vue&type=script&lang=js"
export * from "./SVGUndo.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__